import {useIntl} from 'react-intl';
import {AssigneeGroup, Checkbox, Table} from 'web-components';
import React from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import {personIsVirtualUser} from '../../../forecast-app/shared/util/PermissionsUtil';
import {MODAL_TYPE, showModal} from '../../../forecast-app/shared/components/modals/generic_modal_conductor';
import {createToast} from '../../../forecast-app/shared/components/toasts/another-toast/toaster';
import DeleteSkillMutation from '../../../mutations/delete_skill_mutation';
import Util from '../../../forecast-app/shared/util/util';
import {profilePicSrc} from "../../../constants";
import {DeactivatedUsers} from "./SkillRow.styled";
import * as tracking from '../../../tracking';
import {ActionMenuWrapper} from "./TableRow.styled";

const SkillRow = ({company, tableColumnsProps, checked, toggleSelect, skill, cy}) => {
	const {formatMessage} = useIntl();

	function openSkill() {
		tracking.trackEvent("skills - skill selected");
		showModal({
			type: MODAL_TYPE.UPDATE_SKILL,
			skillId: skill.id,
		});
	}

	function getActionsMenuOptions() {
		return [
			{
				text: formatMessage({id: 'settings_skills.delete_skill'}),
				cy: 'delete',
				onClick: () => {
					showModal({
						type: MODAL_TYPE.CONFIRM_SKILL_DELETION,
						title: formatMessage({id: 'settings_skills.delete_title'}, {name: skill.name}),
						warningMessage: formatMessage({id: 'settings_skills.delete_warning'}),
						confirmText: formatMessage({id: 'settings.confirm'}),
						onDelete: () => {
							Util.CommitMutation(
								DeleteSkillMutation,
								{
									id: skill.id,
									companyId: company.id,
								},
								() => {
									createToast({
										duration: 5000,
										message: formatMessage({id: 'settings_skills.delete_toast'}, {name: skill.name}),
									});
								}
							);
						},
					});
				},
			},
		].filter(Boolean);
	}

	const persons = skill.persons?.edges.map(edge => {
		return {...edge.node, imageSource: edge.node.profilePictureId ? profilePicSrc(edge.node.profilePictureId) : null,};
	});

	return (
		<Table.Row hoverStyle={{visibility: 'visible'}} cy={cy} onClick={openSkill} {...tableColumnsProps}>
			<Table.Column>
				<Table.Column.Cell>
					<Checkbox checked={checked} onClick={toggleSelect} cy={'checkbox'} />
					<span>{skill.name}</span>
				</Table.Column.Cell>
			</Table.Column>
			<Table.Column>
				<Table.Column.Cell>
					<AssigneeGroup hideCountFrame alignStart iconSpaceBetween={4} showCount={3} assignees={persons?.filter(person => person.active && !personIsVirtualUser(person)) || []} />
				</Table.Column.Cell>
			</Table.Column>
			<Table.Column>
				<Table.Column.Cell>
					<AssigneeGroup hideCountFrame alignStart iconSpaceBetween={4} showCount={3} assignees={persons?.filter(person => person.active && personIsVirtualUser(person)) || []} />
				</Table.Column.Cell>
			</Table.Column>
			<Table.Column>
				<DeactivatedUsers>
					<AssigneeGroup hideCountFrame alignStart iconSpaceBetween={4} showCount={3} assignees={persons?.filter(person => !person.active) || []} />
				</DeactivatedUsers>
			</Table.Column>
			<Table.Column>
				<Table.Column.Cell>
					<ActionMenuWrapper cy={'skill'} className={'row-hover'} whiteInner={true} options={getActionsMenuOptions()} />
				</Table.Column.Cell>
			</Table.Column>
		</Table.Row>
	);
};

export default createFragmentContainer(SkillRow, {
	company: graphql`
		fragment SkillRow_company on Company {
			id
		}
	`,
	skill: graphql`
		fragment SkillRow_skill on Skill {
			id
			name
			persons {
				edges {
					node {
						id
						fullName
						active
						permissions
						profilePictureId
					}
				}
			}
		}
	`,
});
